import Filter from '../../../components/DataTable/@types/Filter';

export default function addKioskTerminalFilters(filters: Filter[]): Filter[] {
  filters.push(
    {
      displayKey: 'Payment Terminal',
      displayValue: 'Online',
      key: 'read',
      value: 'gte',
    },
    {
      displayKey: 'Payment Terminal',
      displayValue: 'Offline',
      key: 'read',
      value: 'lte',
    }
  );

  return filters;
}
